<div>
  <!-- Modern Dashboard Header -->
  <div class="dashboard-header" fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutGap.lt-md="16px">
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
          <h1 class="dashboard-title">{{ data?.name }}</h1>
          <button *ngIf="!released && data?.renderReleaseStatus !== renderReleaseStatuses.Released" 
            mat-icon-button color="white" matTooltip="Edit name" (click)="edit('name')">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <h2 class="company-name">{{ selectedCompany?.name || selectedCompany?.code }} • Priority {{ data?.priority || 0 }}</h2>
        <h3 class="dashboard-subtitle" *ngIf="data?.description">
          {{ data?.description }}
          <button *ngIf="!released && data?.renderReleaseStatus !== renderReleaseStatuses.Released"
            mat-icon-button color="white" matTooltip="Edit description" (click)="edit('description')">
            <mat-icon style="font-size: 16px;">edit</mat-icon>
          </button>
        </h3>
        <h3 class="dashboard-subtitle" *ngIf="!data?.description && !released && data?.renderReleaseStatus !== renderReleaseStatuses.Released">
          <span style="opacity: 0.6">No description</span>
          <button mat-icon-button color="white" matTooltip="Add description" (click)="edit('description')">
            <mat-icon style="font-size: 16px;">add</mat-icon>
          </button>
        </h3>
      </div>
      
      <div fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="12px">
        <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center center">
          <button *ngIf="!released" mat-raised-button
            color="primary"
            [matTooltip]="(isExpired(data?.releaseDate) || data?.renderReleaseStatus === renderReleaseStatuses.Released) ? 'Re-enable release' : 'Extend release date'"
            (click)="addDays()">
            <mat-icon>more_time</mat-icon>
            {{ (isExpired(data?.releaseDate) || data?.renderReleaseStatus === renderReleaseStatuses.Released) ? 'Re-enable' : 'Extend' }}
          </button>
          <button mat-raised-button
            [color]="data?.renderReleaseStatus === renderReleaseStatuses.PreRelease ? 'accent' : 'primary'"
            [matTooltip]="data?.renderReleaseStatus === renderReleaseStatuses.PreRelease ? 'Pre-Release Mode ON' : 'Pre-Release Mode OFF'"
            (click)="togglePreRelease()"
            *ngIf="!released && !isExpired(data?.releaseDate) && data?.renderReleaseStatus !== renderReleaseStatuses.Released">
            <mat-icon>science</mat-icon>
            Pre-Release {{ data?.renderReleaseStatus === renderReleaseStatuses.PreRelease ? 'ON' : 'OFF' }}
          </button>
          <button mat-raised-button 
            color="accent"
            matTooltip="Mark release as released" 
            (click)="markAsReleased()"
            *ngIf="!released && !isExpired(data?.releaseDate) && data?.renderReleaseStatus !== renderReleaseStatuses.Released">
            <mat-icon>check_circle</mat-icon>
            Mark as Released
          </button>
        </div>
        <div class="release-meta">
          <span [class.expired]="isExpired(data?.releaseDate)">
            <mat-icon style="font-size: 16px; vertical-align: text-bottom;">schedule</mat-icon>
            {{ isExpired(data?.releaseDate) ? 'Expired' : 'Active until' }} {{ data?.releaseDate | date:'short' }}
          </span>
        </div>
      </div>
    </div>
    
    <!-- Product Toggles -->
    <div *ngIf="!released" class="product-toggles" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <button mat-stroked-button
        class="product-toggle"
        [class.active]="data?.situRaytracedPlus"
        [disabled]="released || data?.renderReleaseStatus === renderReleaseStatuses.Released"
        (click)="toggleRaytraced()">
        <mat-icon [style.color]="data?.situRaytracedPlus ? getProductColour(productNames.RayTracedPlus) : 'inherit'">panorama</mat-icon>
        RayTraced+
      </button>
      <button mat-stroked-button 
        class="product-toggle"
        [class.active]="data?.situPlan"
        [disabled]="released || data?.renderReleaseStatus === renderReleaseStatuses.Released"
        (click)="toggleSituPlan()">
        <mat-icon [style.color]="data?.situPlan ? getProductColour(productNames.Plan) : 'inherit'">foundation</mat-icon>
        situPLAN
      </button>
      <button mat-stroked-button
        class="product-toggle"
        [class.active]="data?.situRender"
        [disabled]="released || data?.renderReleaseStatus === renderReleaseStatuses.Released"
        (click)="toggleSituRender()">
        <mat-icon [style.color]="data?.situRender ? getProductColour(productNames.Render) : 'inherit'">photo_camera</mat-icon>
        situRENDER
      </button>
      <button mat-stroked-button
        class="product-toggle"
        [class.active]="data?.skipRaytraced"
        [disabled]="released || data?.renderReleaseStatus === renderReleaseStatuses.Released"
        (click)="toggleSkipRaytraced()"
        matTooltip="Skip Raytraced rendering for this release">
        <mat-icon [style.color]="data?.skipRaytraced ? '#ff9800' : 'inherit'">block</mat-icon>
        Skip Raytraced
      </button>
    </div>

    <!-- Renderer Pools -->
    <div *ngIf="!released" class="renderer-pools" fxLayout="row" fxLayoutAlign="start center"
      fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start stretch" fxLayoutGap="16px">
      <!-- Pool toggles (situ only) -->
      <div *ngIf="isSituUser" class="pool-toggles" fxLayout="row wrap" fxLayoutAlign="start center">
        <span class="pool-toggles-label">Renderer pools:</span>
        <button *ngFor="let poolName of rendererPoolOptions" mat-stroked-button
          class="product-toggle pool-toggle"
          [class.active]="isPoolSelected(poolName)"
          [disabled]="data?.renderReleaseStatus === renderReleaseStatuses.Released"
          (click)="togglePool(poolName)"
          [matTooltip]="isPoolSelected(poolName) ? 'Click to remove this renderer pool' : 'Click to allow this renderer pool'">
          <mat-icon>{{ isPoolSelected(poolName) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          {{ poolName }}
        </button>
        <span *ngIf="rendererPoolOptions.length === 0" class="pool-toggles-empty">No renderer pools configured</span>
      </div>

      <!-- Express Facade toggle (Burbank) -->
      <button *ngIf="isBurbank" mat-raised-button
        [color]="isFacadePriorityOn ? 'accent' : 'primary'"
        class="express-facade-btn"
        [class.active]="isFacadePriorityOn"
        [disabled]="data?.renderReleaseStatus === renderReleaseStatuses.Released"
        (click)="toggleFacadePriorityPool()"
        [matTooltip]="isFacadePriorityOn
          ? 'Express Facade ON — facade-priority pool assigned. Click to turn off.'
          : 'Express Facade OFF — click to add the facade-priority renderer pool.'">
        <mat-icon>bolt</mat-icon><span class="express-facade-label">Express Facade {{ isFacadePriorityOn ? 'ON' : 'OFF' }}</span>
      </button>
    </div>

    <!-- Daydream source: one line. The saved source, or the situlink entry while one is being chosen. The prompt is never shown. -->
    <div *ngIf="!released" class="daydream-source" fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start stretch" fxLayoutGap="8px">
      <span class="daydream-source-label"><mat-icon>auto_awesome</mat-icon> Daydream source:</span>

      <ng-container *ngIf="!daydreamSourceEditing">
        <ng-container *ngIf="daydreamSource; else noSource">
          <span *ngIf="daydreamSourceImageUrl()" class="daydream-source-thumb-wrap">
            <img [src]="daydreamSourceImageUrl()" alt="Daydream" class="daydream-source-thumb">
            <img [src]="daydreamSourceImageUrl(daydreamSource, 960)" alt="Daydream" class="daydream-source-peek">
          </span>
          <span class="daydream-source-summary" [matTooltip]="'by ' + daydreamSource.createdByName + ' on ' + (daydreamSource.dateCreated | date:'medium')">
            <strong>{{ daydreamSource.companyName }}</strong> · {{ daydreamSource.home }} · {{ daydreamSource.masterFile }}<span *ngIf="daydreamSource.styleTemplate"> · {{ daydreamSource.styleTemplate }}</span>
          </span>
          <button mat-icon-button color="accent" (click)="shareDaydreamSource()" matTooltip="Share Daydream situLINK"><mat-icon>share</mat-icon></button>
          <button mat-icon-button [disabled]="data?.renderReleaseStatus === renderReleaseStatuses.Released" (click)="editDaydreamSource()" matTooltip="Change the Daydream source"><mat-icon>edit</mat-icon></button>
          <button mat-icon-button [disabled]="data?.renderReleaseStatus === renderReleaseStatuses.Released" (click)="clearDaydreamSource()" matTooltip="Remove the Daydream source"><mat-icon>close</mat-icon></button>
          <button *ngIf="failedDaydreamItemIds().length" mat-stroked-button color="warn" class="product-toggle"
            (click)="retryFailedDaydreamsConfirm()" matTooltip="Render the Daydream again for every facade in this release whose Daydream failed">
            <mat-icon>replay</mat-icon> Retry {{ failedDaydreamItemIds().length }} failed
          </button>
        </ng-container>
        <ng-template #noSource>
          <mat-spinner *ngIf="daydreamSourceLoading" diameter="20"></mat-spinner>
          <span *ngIf="!daydreamSourceLoading && data?.daydreamSourceRenderedOutputId" class="daydream-source-error">{{ daydreamSourceError || 'The saved Daydream source could not be loaded.' }}</span>
          <button *ngIf="!daydreamSourceLoading" mat-stroked-button class="product-toggle"
            [disabled]="data?.renderReleaseStatus === renderReleaseStatuses.Released" (click)="editDaydreamSource()">
            <mat-icon>link</mat-icon> Enter a situlink
          </button>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="daydreamSourceEditing">
        <mat-form-field appearance="outline" class="daydream-source-field" subscriptSizing="dynamic">
          <input matInput type="text" [(ngModel)]="daydreamSourceInput" name="daydreamSourceInput"
            placeholder="Paste a Daydream situlink"
            (keyup.enter)="previewDaydreamSource()">
        </mat-form-field>
        <button mat-stroked-button class="product-toggle" [disabled]="daydreamSourceLoading || !daydreamSourceInput" (click)="previewDaydreamSource()">
          <mat-icon>preview</mat-icon> Preview
        </button>
        <ng-container *ngIf="daydreamSourceCandidate">
          <span *ngIf="daydreamSourceImageUrl(daydreamSourceCandidate)" class="daydream-source-thumb-wrap">
            <img [src]="daydreamSourceImageUrl(daydreamSourceCandidate)" alt="Daydream" class="daydream-source-thumb">
            <img [src]="daydreamSourceImageUrl(daydreamSourceCandidate, 960)" alt="Daydream" class="daydream-source-peek">
          </span>
          <span class="daydream-source-summary"><strong>{{ daydreamSourceCandidate.companyName }}</strong> · {{ daydreamSourceCandidate.home }} · {{ daydreamSourceCandidate.masterFile }}<span *ngIf="daydreamSourceCandidate.styleTemplate"> · {{ daydreamSourceCandidate.styleTemplate }}</span></span>
          <button mat-raised-button color="accent" [disabled]="daydreamSourceLoading || daydreamSourceCandidate.id === data?.daydreamSourceRenderedOutputId" (click)="saveDaydreamSource()">
            <mat-icon>save</mat-icon> Use as source
          </button>
        </ng-container>
        <button mat-stroked-button class="product-toggle" [disabled]="daydreamSourceLoading" (click)="cancelDaydreamSourceEdit()">Cancel</button>
        <mat-spinner *ngIf="daydreamSourceLoading" diameter="20"></mat-spinner>
        <span *ngIf="daydreamSourceError" class="daydream-source-error">{{ daydreamSourceError }}</span>
      </ng-container>
    </div>
  </div>

  <!-- Dashboard Content -->
  <div class="dashboard-content" fxLayout="column" fxLayoutGap="12px">
    
    <!-- Release Overview -->
    <app-release-overview *ngIf="!released"
      [releaseId]="id"
      [selectedCompany]="selectedCompany"
      [isCompact]="true"
      [isDarkModeInput]="isDarkMode">
    </app-release-overview>

    <!-- Stats and Chart Row -->
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
      <!-- Content Stats Grid (Left Half) -->
      <div fxFlex="50" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8px">
        <!-- Progress Row -->
        <div fxLayout="row" fxLayoutGap="8px">
          <mat-card class="metric-card" fxFlex="50" fxFlex.lt-sm="100">
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
              <div class="metric-value" [style.color]="'hsl(280, 70%, 55%)'">{{ getLivePercentage() }}%</div>
              <div class="metric-label">Progress</div>
              <div class="metric-subtitle">Items complete</div>
            </mat-card-content>
          </mat-card>
          
          <mat-card class="metric-card" fxFlex="50" fxFlex.lt-sm="100">
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
              <mat-icon color="primary" style="font-size: 32px; width: 32px; height: 32px; margin-bottom: 8px;">schedule</mat-icon>
              <div class="metric-value" style="font-size: 20px;">{{ formatRenderTime(releaseStats.totalRenderTimeRemaining) }}</div>
              <div class="metric-label">Time Remaining</div>
            </mat-card-content>
          </mat-card>
        </div>
        
        <!-- Second Row of Stats -->
        <div fxLayout="row" fxLayoutGap="8px">
          <mat-card class="metric-card" fxFlex="50" fxFlex.lt-sm="100">
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
              <div class="metric-value" [style.color]="'hsl(190, 70%, 55%)'">{{ releaseStats?.uniqueHomes || 0 }}</div>
              <div class="metric-label">Unique Homes</div>
            </mat-card-content>
          </mat-card>
          
          <mat-card class="metric-card" fxFlex="50" fxFlex.lt-sm="100">
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
              <div class="metric-value" [style.color]="'hsl(60, 80%, 55%)'">{{ releaseStats?.uniqueMasterFiles || 0 }}</div>
              <div class="metric-label">Master Files</div>
            </mat-card-content>
          </mat-card>
        </div>
        
        <!-- Third Row of Stats -->
        <div fxLayout="row" fxLayoutGap="8px">
          <mat-card class="metric-card" fxFlex="50" fxFlex.lt-sm="100">
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
              <div class="metric-value" [style.color]="'hsl(145, 60%, 55%)'">{{ releaseStats?.uniqueStyleTemplates || 0 }}</div>
              <div class="metric-label">Style Templates</div>
            </mat-card-content>
          </mat-card>
          
          <mat-card class="metric-card" fxFlex="50" fxFlex.lt-sm="100">
            <mat-card-content fxLayout="column" fxLayoutAlign="center center">
              <div class="metric-value" [style.color]="'hsl(280, 70%, 55%)'">{{ releaseStats?.uniqueOptions || 0 }}</div>
              <div class="metric-label">Options</div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <!-- Status Distribution Chart (Right Half) -->
      <mat-card class="chart-card" fxFlex="50" fxFlex.lt-md="100">
        <mat-card-header>
          <mat-card-title [style.color]="'hsl(210, 90%, 55%)'">Status Distribution</mat-card-title>
          <mat-card-subtitle>Current release item statuses</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutGap="12px">
          <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
            <chart *ngIf="statusPercentages && statusPercentages.length > 0"
              [type]="'pie'"
              [data]="statusChartData"
              [labels]="statusChartLabels"
              [colors]="statusChartColors"
              [slimMode]="true"
              [useCardWrapper]="false"
              [isDarkMode]="isDarkMode"
              (chartClick)="onChartClick($event)">
            </chart>
          </div>
          <div fxFlex="40" class="table-section" [style.--section-color]="'hsl(210, 90%, 55%)'">
            <h4 [style.color]="'hsl(210, 90%, 55%)'">Status Breakdown</h4>
            <div class="data-row clickable" 
              *ngFor="let status of statusPercentages" 
              (click)="filterReleaseStatus(status.status)">
              <span class="data-label">{{ releaseStatuses[status.status] }}:</span>
              <span class="data-value">{{ status.count }}</span>
            </div>
            <div class="data-row highlight">
              <span class="data-label">Total:</span>
              <span class="data-value">{{ getTotalStatusCount() }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div fxLayout="column">
  <!-- Release Issues -->
  <mat-card *ngIf="!released" fxFlex>
    <mat-card-content>
      <div class="m-b-10" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
            <span [ngClass.lt-sm]="{'card-title': true}">Issues</span>
          </div>
        </div>
        <div>
          <button mat-flat-button color="primary" class="m-r-10" (click)="addEditReleaseIssue()">
            Add Issue<mat-icon>bug_report</mat-icon>
          </button>
          <a *ngIf="id" mat-flat-button color="accent" [href]="'/admin/release-issues?release=' + id" target="_blank">
            View Dashboard<mat-icon>dashboard</mat-icon>
          </a>
          <button mat-icon-button>
            <mat-icon *ngIf="!showReleaseIssues" matTooltip="Show Issues" (click)="showReleaseIssues = true">expand_more</mat-icon>
            <mat-icon *ngIf="showReleaseIssues" matTooltip="Hide Issues" (click)="showReleaseIssues = false">expand_less</mat-icon>
          </button>
        </div>
      </div>
      <release-issue-list *ngIf="showReleaseIssues"
        [companyId]="selectedCompany?.id"
        [hideEdit]="false"
        [isSituUser]="isSituUser"
        [hideReport]="false"
        [isSelectable]="true"
        [selectedReleaseIssue]="issueFilter"
        (onSelectClick)="onCardSelectClick($event)">
      </release-issue-list>
    </mat-card-content>
  </mat-card>
  <!-- Release Issues -->

  <!-- Release Items -->
  <mat-card fxFlex>
    <mat-card-content fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button *ngIf="!released && isSituUser" mat-flat-button color="primary" (click)="uploadCSV()" matTooltip="Upload CSV to import release items">
          Import Release Items
          <mat-icon>file_upload</mat-icon>
        </button>
        <button *ngIf="!top100" mat-flat-button color="accent" (click)="downloadJSON()">
          Export JSON
          <mat-icon>data_object</mat-icon>
        </button>
        <button mat-flat-button color="accent" (click)="downloadCSV()">
          Export CSV
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
      <mat-card class="mat-card-inline-sm">
        <mat-card-content>
          <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
            <mat-form-field class="accent">
              <mat-label>Search release items</mat-label>
              <input matInput type="text"
                [(ngModel)]="searchTerm"
                (keyup.enter)="filterData()"
                (keyup.esc)="clearSearch(); filterData()"
                name="searchTerm"
                placeholder="Search release items">
              <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch(); filterData()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="10px">
              <button type="submit"
                mat-mini-fab color="primary"
                (click)="filterData()"
                matTooltip="Search"
                [class.button-spinner]="loading"
                [disabled]="loading">
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="m-b-20 w-100" fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <small class="text-info"><i>filter:</i></small>
          <small *ngIf="!selectedHome && 
          !selectedMasterFile && 
          !selectedOption && 
          !selectedStyleTemplate && 
          selectedReleaseStatus === undefined && 
          selectedProductName === undefined &&
          !commentsFilter &&
          !ticketFilter &&
          !standardFilter &&
          !hiResFilter &&
          !viewedFilter &&
          !issueFilter" class="text-warning">
            no filters currently applied
          </small>
          <mat-chip-list>
            <mat-chip *ngIf="selectedHome" color="accent">
              <span>Home: {{ selectedHome }}</span>
              <button matChipRemove (click)="filterHome(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedMasterFile" color="accent">
              <span>MasterFile: {{ selectedMasterFile }}</span>
              <button matChipRemove (click)="filterMasterFile(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedOption" color="accent">
              <span>Options: {{ selectedOption }}</span>
              <button matChipRemove (click)="filterOption(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedStyleTemplate" color="accent">
              <span>Style Template: {{ selectedStyleTemplate }}</span>
              <button matChipRemove (click)="filterStyleTemplate(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedReleaseStatus" color="accent">
              <span>Status: {{ releaseStatuses[selectedReleaseStatus] }}</span>
              <button matChipRemove (click)="filterReleaseStatus(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedProductName !== undefined" color="accent">
              <span>Product: {{ productNames[selectedProductName] }}</span>
              <button matChipRemove (click)="filterProductName(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="issueFilter" color="accent">
              <span>Release Issue</span>
              <button matChipRemove (click)="filterIssue(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="commentsFilter ? filterComments(false) : filterComments(true)">
              <span>Comments</span>
              <button matChipRemove>
                <mat-icon *ngIf="!commentsFilter" color="basic" matTooltip="Show Commented Release Items" (click)="filterComments(true)">comment</mat-icon>
                <mat-icon *ngIf="commentsFilter" color="primary" matTooltip="Clear filter" (click)="filterComments(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="ticketFilter ? filterTickets(false) : filterTickets(true)">
              <span>Tickets</span>
              <button matChipRemove>
                <mat-icon *ngIf="!ticketFilter" color="basic" matTooltip="Show Ticketed Release Items" (click)="filterTickets(true)">support</mat-icon>
                <mat-icon *ngIf="ticketFilter" color="primary" matTooltip="Clear filter" (click)="filterTickets(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="standardFilter ? filterStandard(false) : filterStandard(true)">
              <span>Geometry Check</span>
              <button matChipRemove>
                <mat-icon *ngIf="!standardFilter" color="basic" matTooltip="Show Geometry Check Release Items" (click)="filterStandard(true)">architecture</mat-icon>
                <mat-icon *ngIf="standardFilter" color="primary" matTooltip="Clear filter" (click)="filterStandard(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="draftFilter ? filterDraft(false) : filterDraft(true)">
              <span>Draft</span>
              <button matChipRemove>
                <mat-icon *ngIf="!draftFilter" color="basic" matTooltip="Show Draft Release Items" (click)="filterDraft(true)">2k_plus</mat-icon>
                <mat-icon *ngIf="draftFilter" color="primary" matTooltip="Clear filter" (click)="filterDraft(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="hiResFilter ? filterHiRes(false) : filterHiRes(true)">
              <span>HiRes</span>
              <button matChipRemove>
                <mat-icon *ngIf="!hiResFilter" color="basic" matTooltip="Show HiRes Release Items" (click)="filterHiRes(true)">4k_plus</mat-icon>
                <mat-icon *ngIf="hiResFilter" color="primary" matTooltip="Clear filter" (click)="filterHiRes(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="viewedFilter ? filterViewed(false) : filterViewed(true)">
              <span>Viewed</span>
              <button matChipRemove>
                <mat-icon *ngIf="!viewedFilter" color="basic" matTooltip="Show Viewed Release Items" (click)="filterViewed(true)">visibility</mat-icon>
                <mat-icon *ngIf="viewedFilter" color="primary" matTooltip="Clear filter" (click)="filterViewed(false)">clear</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <mat-card *ngIf="!isExpired(data?.releaseDate) && data?.renderReleaseStatus !== renderReleaseStatuses.Released" class="contrast mat-card-inline-sm">
        <mat-card-content fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="start center">
          <div fxFlex="20" class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
            fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label><span class="text-info">{{ selectedReleaseItems ? selectedReleaseItems.length : 0 }}</span> items selected.</label>
          </div>
          <div fxFlex="50" fxLayout="row" fxLayoutAlign="center center">
            <mat-form-field *ngIf="releaseItemFieldToUpdate !== undefined && releaseItemFieldToUpdate !== releaseItemFieldToUpdateOptions.Delete && selectedReleaseItems?.length > 0">
              <input *ngIf="releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.Comments || releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.SupportTicket" matInput type="text"
                [(ngModel)]="updateReleaseItemValue"
                name="updateReleaseItemValue"
                [placeholder]="'Set ' + releaseItemFieldToUpdateOptions[releaseItemFieldToUpdate]"
                required>
              <mat-select *ngIf="releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.ReleaseStatus"
                [(ngModel)]="updateReleaseItemEnumValue"
                name="updateReleaseItemEnumValue"
                required>
                <mat-option *ngFor="let status of availableStatuses" [value]="status.value">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="m-r-10 chart-select-color" [style.background-color]="status.color"></div>
                    <div>{{ status.key }}</div>
                  </div>
                </mat-option>
              </mat-select>
              <mat-select *ngIf="releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.AssignToReleaseIssue"
                [(ngModel)]="updateReleaseItemValue"
                name="updateReleaseItemValue"
                required>
                <mat-option *ngFor="let item of releaseIssues" [value]="item.id">
                  {{ item.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button *ngIf="releaseItemFieldToUpdate !== undefined && selectedReleaseItems?.length > 0" [disabled]="!updateReleaseItemValue && !updateReleaseItemEnumValue"
                mat-button mat-icon-button
                [matTooltip]="'Set ' + releaseItemFieldToUpdateOptions[releaseItemFieldToUpdate]"
                (click)="setValues()"
                color="accent">
                <mat-icon>done</mat-icon>
              </button>
          </div>
          <div fxFlex="30" fxLayout="row" fxLayoutAlign="end center">
            <button
              mat-icon-button color="accent"
              matTooltip="Select All"
              aria-label="Select All"
              (click)="selectAll()">
              <mat-icon>select_all</mat-icon>
            </button>
            <ng-container>
              <button *ngIf="!released" mat-icon-button [disabled]="selectedReleaseItems?.length === 0 || availableStatuses?.length === 0"
                color="primary"
                [matTooltip]="getSetStatusTooltip()"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.ReleaseStatus; clearValues();">
                <mat-icon>military_tech</mat-icon>
              </button>
              <button *ngIf="!released && !isSituUser" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Set comment"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.Comments; clearValues();">
                <mat-icon>comment</mat-icon>
              </button>
              <button *ngIf="!released && !isSituUser" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Set support ticket"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.SupportTicket; clearValues();">
                <mat-icon>support</mat-icon>
              </button>
              <button *ngIf="!released && isSituUser" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Assign to release issue"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.AssignToReleaseIssue; clearValues();">
                <mat-icon>bug_report</mat-icon>
              </button>
              <button *ngIf="!released && data?.daydreamSourceRenderedOutputId" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Render Daydreams of the selected facades"
                (click)="requestDaydreamConfirm()">
                <mat-icon>auto_awesome</mat-icon>
              </button>
              <!-- the tooltip sits on a wrapper: a disabled button shows none, and it says why this one is disabled -->
              <span *ngIf="!released && releaseHasFacades()" [matTooltip]="approveDaydreamsTooltip()">
                <button mat-icon-button [disabled]="!canApproveDaydreams()"
                  color="accent"
                  (click)="approveDaydreamsConfirm()">
                  <mat-icon>verified</mat-icon>
                </button>
              </span>
              <span *ngIf="!released && releaseHasFacades()" [matTooltip]="downloadDaydreamsTooltip()">
                <button mat-icon-button [disabled]="!canDownloadDaydreams()"
                  color="accent"
                  (click)="downloadSelectedDaydreams()">
                  <mat-icon>download_for_offline</mat-icon>
                </button>
              </span>
              <button *ngIf="!released" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Delete release items"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.Delete; deleteConfirm()">
                <mat-icon>delete</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-template matMenuContent>
                  <button *ngFor="let release of releases" mat-menu-item (click)="addToRelease(release.id)">
                    <span>{{ release?.name }}</span>
                  </button>
                </ng-template>
              </mat-menu>
              <button *ngIf="selectedReleaseItems?.length > 0 && released" 
                [matMenuTriggerFor]="menu"
                color="accent" mat-icon-button matTooltip="Add configurations to release" aria-label="Add configurations to release">
                <mat-icon>queue</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0"
                mat-icon-button color="basic"
                matTooltip="Cancel Select"
                aria-label="Cancel Select"
                (click)="clearSelection()">
                <mat-icon>deselect</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0"
                mat-icon-button color="primary"
                matTooltip="Copy to Style Template(s)"
                aria-label="Copy to Style Template(s)"
                (click)="copyToStyleTemplate()">
                <mat-icon>queue</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0 && selectedProductName === productNames.Facade"
                mat-icon-button color="primary"
                matTooltip="Download Facades"
                aria-label="Download Facades"
                (click)="downloadSelectedFacades()">
                <mat-icon>file_download</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0 && selectedProductName === productNames.Facade"
                mat-icon-button color="accent"
                matTooltip="Download HiRes Facades"
                aria-label="Download HiRes Facades"
                (click)="downloadSelectedFacades(true)">
                <mat-icon>file_download</mat-icon>
              </button>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="(isExpired(data?.releaseDate) || data?.renderReleaseStatus === renderReleaseStatuses.Released) && selectedReleaseItems?.length > 0 && selectedProductName === productNames.Facade" class="contrast mat-card-inline-sm">
        <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="20" class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
            fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label><span class="text-info">{{ selectedReleaseItems ? selectedReleaseItems.length : 0 }}</span> items selected.</label>
          </div>
          <div fxLayoutAlign="end center" fxLayout="row">
            <button
              mat-icon-button color="accent"
              matTooltip="Select All"
              aria-label="Select All"
              (click)="selectAll()">
              <mat-icon>select_all</mat-icon>
            </button>
            <button *ngIf="selectedReleaseItems?.length > 0"
              mat-icon-button color="basic"
              matTooltip="Cancel Select"
              aria-label="Cancel Select"
              (click)="clearSelection()">
              <mat-icon>deselect</mat-icon>
            </button>
            <span *ngIf="!released" [matTooltip]="approveDaydreamsTooltip()">
              <button mat-icon-button [disabled]="!canApproveDaydreams()"
                color="accent"
                (click)="approveDaydreamsConfirm()">
                <mat-icon>verified</mat-icon>
              </button>
            </span>
            <span *ngIf="!released" [matTooltip]="downloadDaydreamsTooltip()">
              <button mat-icon-button [disabled]="!canDownloadDaydreams()"
                color="accent"
                (click)="downloadSelectedDaydreams()">
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </span>
            <button mat-icon-button color="primary"
              matTooltip="Download Facades"
              aria-label="Download Facades"
              (click)="downloadSelectedFacades()">
              <mat-icon>file_download</mat-icon>
            </button>
            <button mat-icon-button color="accent"
              matTooltip="Download HiRes Facades"
              aria-label="Download HiRes Facades"
              (click)="downloadSelectedFacades(true)">
              <mat-icon>file_download</mat-icon>
            </button>
          </div>
          
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="(isExpired(data?.releaseDate) || data?.renderReleaseStatus === renderReleaseStatuses.Released) && selectedReleaseItems?.length > 0 && selectedProductName !== productNames.Facade" class="contrast mat-card-inline-sm">
        <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="20" class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
            fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label><span class="text-info">{{ selectedReleaseItems ? selectedReleaseItems.length : 0 }}</span> items selected.</label>
          </div>
          <div fxLayoutAlign="end center" fxLayout="row">
            <button
              mat-icon-button color="accent"
              matTooltip="Select All"
              aria-label="Select All"
              (click)="selectAll()">
              <mat-icon>select_all</mat-icon>
            </button>
            <button *ngIf="selectedReleaseItems?.length > 0"
              mat-icon-button color="basic"
              matTooltip="Cancel Select"
              aria-label="Cancel Select"
              (click)="clearSelection()">
              <mat-icon>deselect</mat-icon>
            </button>
            <span *ngIf="!released && releaseHasFacades()" [matTooltip]="approveDaydreamsTooltip()">
              <button mat-icon-button [disabled]="!canApproveDaydreams()"
                color="accent"
                (click)="approveDaydreamsConfirm()">
                <mat-icon>verified</mat-icon>
              </button>
            </span>
            <span *ngIf="!released && releaseHasFacades()" [matTooltip]="downloadDaydreamsTooltip()">
              <button mat-icon-button [disabled]="!canDownloadDaydreams()"
                color="accent"
                (click)="downloadSelectedDaydreams()">
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </span>
            <button *ngIf="selectedReleaseItems?.length > 0"
              mat-icon-button color="primary"
              matTooltip="Copy to Style Template(s)"
              aria-label="Copy to Style Template(s)"
              (click)="copyToStyleTemplate()">
              <mat-icon>queue</mat-icon>
            </button>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="contrast mat-card-inline-sm">
        <div></div>
        <mat-card-content>
          <div fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
              <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="2px">
                <strong fxLayout="row" class="highlight" fxLayoutAlign="start center" matTooltip="Sorting by {{ getSortCriteriaName(sortCriteria) }}">{{ getSortCriteriaName(sortCriteria) }}</strong>
                <button [color]="sortOrder == 'asc' ? 'accent' : 'basic'" matTooltip="Sort Ascending" (click)="sortOrder = 'asc'; filterData();" mat-icon-button><mat-icon>expand_less</mat-icon></button> 
                <button [color]="sortOrder == 'desc' ? 'accent' : 'basic'" matTooltip="Sort Descending" (click)="sortOrder = 'desc'; filterData();" mat-icon-button><mat-icon>expand_more</mat-icon></button>
              </div>
              <small [class.link]="sortCriteria != 'home'" [class.highlight]="sortCriteria === 'home'" matTooltip="Sort by Home" (click)="sortCriteria = 'home'; filterData();">Home</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'masterFile'" [class.highlight]="sortCriteria === 'masterFile'" matTooltip="Sort by MasterFile" (click)="sortCriteria = 'masterFile'; filterData();">MasterFile</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'option'" [class.highlight]="sortCriteria === 'option'" matTooltip="Sort by Options" (click)="sortCriteria = 'option'; filterData();">Options</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'styleTemplate'" [class.highlight]="sortCriteria === 'styleTemplate'" matTooltip="Sort by Style Template" (click)="sortCriteria = 'styleTemplate'; filterData();">Style Template</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'renderType'" [class.highlight]="sortCriteria === 'renderType'" matTooltip="Sort by Render Type" (click)="sortCriteria = 'renderType'; filterData();">Render Type</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'releaseStatus'" [class.highlight]="sortCriteria === 'releaseStatus'" matTooltip="Sort by Release Status" (click)="sortCriteria = 'releaseStatus'; filterData();">Release Status</small>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <ng-container *ngFor="let item of filteredReleaseItems; let i = index;">
        <mat-card class="w-100" fxFlex="100" *ngIf="i < pageLength"
        class="contrast mat-card-inline-sm"
        [class.banner-info]="isSelected(item.id)"
        (click)="toggleSelection(item.id)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5px">
          <div fxFlex="80" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
              <strong fxLayout="row" class="link" fxLayoutAlign="start center" matTooltip="Home" [innerHtml]="item.home | encodeHtml | highlight: searchTerm" (click)="filterHome(item.home, $event); $event.stopPropagation();"></strong>
              <small class="link" [style.color]="getStatusColor(item.releaseStatus)" matTooltip="Master File" [innerHtml]="item.masterFile | encodeHtml | highlight: searchTerm" (click)="filterMasterFile(item.masterFile, $event); $event.stopPropagation();"></small>
              <span *ngIf="item?.options" [fxHide.lt-sm]="true">></span>
              <small class="link" [style.color]="getStatusColor(item.releaseStatus)" matTooltip="Options" *ngIf="item?.options" [innerHtml]="item.options | encodeHtml | highlight: searchTerm" (click)="filterOption(item.options, $event); $event.stopPropagation();"></small>
              <span [fxHide.lt-sm]="true">></span>
              <small class="link" [style.color]="getStatusColor(item.releaseStatus)" matTooltip="Style Template" [innerHtml]="item.styleTemplate | encodeHtml | highlight: searchTerm" (click)="filterStyleTemplate(item.styleTemplate, $event); $event.stopPropagation();"></small>
              <span *ngIf="item?.productName !== undefined" [fxHide.lt-sm]="true">></span>
              <small class="link" *ngIf="item?.productName !== undefined" [style.color]="getProductColour(item.productName)" (click)="filterProductName(item.productName, $event); $event.stopPropagation();">{{ productNames[item.productName] }}</small>
              <span *ngIf="top100 && item?.latestVersion" [fxHide.lt-sm]="true">></span>
              <small *ngIf="top100 && item?.latestVersion" [style.color]="getStatusColor(item.releaseStatus)">views: {{ getViews(item.latestVersion) }}</small>
            </div>
          </div>
          <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="10px">
            <div fxLayoutAlign="end center" fxLayout="row" fxLayoutAlign.lt-sm="center center" class="date-text">
              <small *ngIf="!released" class="link" [style.color]="getStatusColor(item.releaseStatus)" (click)="filterReleaseStatus(item.releaseStatus); $event.stopPropagation();">{{ releaseStatuses[item.releaseStatus] }}</small>
              <div class="m-l-10" *ngIf="!top100 && !released">|</div>
              <button *ngIf="!released && item?.lastViewedName" mat-icon-button matTooltip="Viewed by {{ item?.lastViewedName }} @ {{ item?.dateLastViewed | date:'short' }}" color="accent" (click)="$event.stopPropagation();">
                <mat-icon>visibility</mat-icon>
              </button>
              <button *ngIf="!released && !item?.lastViewedName" mat-icon-button matTooltip="Not viewed" color="primary" (click)="$event.stopPropagation();">
                <mat-icon>visibility_off</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Panorama || item?.productName == productNames.RayTraced"
                      mat-icon-button
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openLinkInNewWindow($event, '/situ-view', { id: item.latestVersion }); setReleaseItemViewed(item.id);"
                      [matTooltip]="renderTooltip('Geometry Check', item?.latestVersion, 'situVIEW')">
                <mat-icon>architecture</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Panorama || item?.productName == productNames.RayTraced"
                      mat-icon-button
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openSituLinkInNewWindow($event, item.latestVersion, false, true); setReleaseItemViewed(item.id);"
                      [matTooltip]="renderTooltip('Geometry Check', item?.latestVersion, 'situLINK')">
                <mat-icon>share</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Panorama || item?.productName == productNames.RayTraced"
                      mat-icon-button
                      [disabled]="!item?.rayTracedDraftVersion"
                      color="primary"
                      (click)="openLinkInNewWindow($event, '/situ-view', { id: item.rayTracedDraftVersion }); setReleaseItemViewed(item.id);"
                      [matTooltip]="renderTooltip('Draft', item?.rayTracedDraftVersion, 'situVIEW')">
                <mat-icon>2k_plus</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Panorama || item?.productName == productNames.RayTraced"
                      mat-icon-button
                      [disabled]="!item?.rayTracedDraftVersion"
                      color="primary"
                      (click)="openSituLinkInNewWindow($event, item.rayTracedDraftVersion, false, true); setReleaseItemViewed(item.id);"
                      [matTooltip]="renderTooltip('Draft', item?.rayTracedDraftVersion, 'situLINK')">
                <mat-icon>share</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Facade"
                      mat-icon-button
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openLinkInNewWindow($event, '/situ-facade', { id: item.latestVersion }); setReleaseItemViewed(item.id);"
                      [matTooltip]="item?.latestVersion ? (released ? 'View home in situFACADE' : 'Latest version available') : ''">
                <mat-icon>panorama</mat-icon>
              </button>
              <button *ngIf="released && canScanForProductUsage(item)"
                      mat-icon-button
                      color="accent"
                      [disabled]="!!scanningArtifactId"
                      [matTooltip]="scanningArtifactId === item.latestVersion ? 'Scanning…' : 'Scan for product usage'"
                      (click)="scanForProductUsage($event, item)">
                <mat-icon *ngIf="scanningArtifactId !== item.latestVersion">fingerprint</mat-icon>
                <mat-spinner *ngIf="scanningArtifactId === item.latestVersion" diameter="20"></mat-spinner>
              </button>
              <button *ngIf="item?.productName == productNames.Facade"
                      mat-icon-button
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openSituLinkInNewWindow($event, item.latestVersion, true, true); setReleaseItemViewed(item.id);"
                      [matTooltip]="item?.latestVersion ? 'Copy situFACADE share link' : ''">
                <mat-icon>share</mat-icon>
              </button>
              <!-- the 2k tick: approves the item as today; on a Live item it serves the 2k again -->
              <button *ngIf="item?.productName == productNames.Facade && !released" mat-icon-button
                  [disabled]="(!item?.latestVersion && item.status !== releaseStatuses.ReadyForReview) || isServed(item, item?.latestVersion)"
                  [color]="isServed(item, item?.latestVersion) || (item?.approvedByName && !item?.approvedVersion) ? 'accent' : 'primary'"
                  (click)="approveStandard(item); $event.stopPropagation();"
                  [matTooltip]="versionTooltip(item, item?.latestVersion, '2k facade')">
                <mat-icon *ngIf="isServed(item, item?.latestVersion) || (item?.approvedByName && !item?.approvedVersion)">how_to_reg</mat-icon>
                <mat-icon *ngIf="!(isServed(item, item?.latestVersion) || (item?.approvedByName && !item?.approvedVersion))">done</mat-icon>
              </button>

              <!-- Daydream of this facade: requested explicitly once the facade is rendered -->
              <ng-container *ngIf="item?.productName == productNames.Facade && !top100">
                <div>|</div>
                <button *ngIf="!released" mat-icon-button
                        [disabled]="!canRequestDaydream(item) || item?.daydreamRequested || isDaydreamGenerating(item)"
                        [color]="item?.daydreamRequested || isDaydreamGenerating(item) ? 'accent' : 'primary'"
                        (click)="requestDaydream(item); $event.stopPropagation();"
                        [matTooltip]="daydreamTooltip(item)">
                  <mat-spinner *ngIf="isDaydreamGenerating(item)" diameter="18" color="accent"></mat-spinner>
                  <mat-icon *ngIf="!isDaydreamGenerating(item) && item?.daydreamRequested">hourglass_top</mat-icon>
                  <mat-icon *ngIf="!isDaydreamGenerating(item) && !item?.daydreamRequested && isDaydreamFailed(item)" color="warn">error_outline</mat-icon>
                  <mat-icon *ngIf="!isDaydreamGenerating(item) && !item?.daydreamRequested && !isDaydreamFailed(item)">auto_awesome</mat-icon>
                </button>
                <button mat-icon-button
                        [disabled]="!hasDaydream(item)"
                        color="accent"
                        (click)="openLinkInNewWindow($event, '/situ-facade', { id: item.daydreamVersion });"
                        [matTooltip]="hasDaydream(item) ? 'View the Daydream' : isDaydreamFailed(item) ? 'The Daydream failed' : 'No Daydream yet'">
                  <mat-icon>auto_awesome_motion</mat-icon>
                </button>
                <button mat-icon-button
                        [disabled]="!hasDaydream(item)"
                        color="accent"
                        (click)="openSituLinkInNewWindow($event, item.daydreamVersion, true, true);"
                        [matTooltip]="hasDaydream(item) ? 'Copy Daydream share link' : ''">
                  <mat-icon>share</mat-icon>
                </button>
                <!-- the Daydream tick: serves the Daydream in place of the facade -->
                <button *ngIf="!released" mat-icon-button
                        [disabled]="!hasDaydream(item) || isServed(item, item?.daydreamVersion)"
                        [color]="isServed(item, item?.daydreamVersion) ? 'accent' : 'primary'"
                        (click)="approveVersion(item, releaseItemVersions.Daydream, 'Daydream'); $event.stopPropagation();"
                        [matTooltip]="hasDaydream(item) ? versionTooltip(item, item?.daydreamVersion, 'Daydream') : 'No Daydream to approve yet'">
                  <mat-icon *ngIf="isServed(item, item?.daydreamVersion)">how_to_reg</mat-icon>
                  <mat-icon *ngIf="!isServed(item, item?.daydreamVersion)">done</mat-icon>
                </button>
              </ng-container>
              
              <ng-container *ngIf="item?.productName == productNames.Panorama && !released">
                <div *ngIf="!top100 && !released">|</div>
                <button mat-icon-button
                        [disabled]="!item?.higherResVersion && item.status !== releaseStatuses.ReadyForLive"
                        color="accent"
                        (click)="openLinkInNewWindow($event, '/situ-view', { id: item.higherResVersion });"
                        [matTooltip]="renderTooltip('RayTraced', item?.higherResVersion, 'situVIEW')">
                  <mat-icon>4k_plus</mat-icon>
                </button>
                <button mat-icon-button
                        [disabled]="!item?.higherResVersion && !released"
                        color="accent"
                        (click)="openSituLinkInNewWindow($event, item.higherResVersion, false);"
                        [matTooltip]="renderTooltip('RayTraced', item?.higherResVersion, 'situLINK')">
                  <mat-icon>share</mat-icon>
                </button>
                <ng-container *ngIf="data?.situRaytracedPlus">
                  <button mat-icon-button
                          [disabled]="!item?.highestResVersion && item.status !== releaseStatuses.ReadyForLive"
                          color="accent"
                          (click)="openLinkInNewWindow($event, '/situ-view', { id: item.highestResVersion });"
                          [matTooltip]="renderTooltip('RayTraced+', item?.highestResVersion, 'situVIEW')">
                    <mat-icon>8k_plus</mat-icon>
                  </button>
                  <button mat-icon-button
                          [disabled]="!item?.highestResVersion && !released"
                          color="accent"
                          (click)="openSituLinkInNewWindow($event, item.highestResVersion, false);"
                          [matTooltip]="renderTooltip('RayTraced+', item?.highestResVersion, 'situLINK')">
                    <mat-icon>share</mat-icon>
                  </button>
                </ng-container>
                
                <button mat-icon-button *ngIf="!released"
                    [disabled]="!item?.higherResVersion && item.status !== releaseStatuses.ReadyForLive"
                    [color]="item?.approvedByName ? 'accent' : 'primary'"
                    (click)="approveForLive(item); $event.stopPropagation();"
                    [matTooltip]="item?.approvedByName ? 'Approved by ' + (item?.approvedByName ? item?.approvedByName : 'N/A') : 'Approve For Live'">
                  <mat-icon *ngIf="item?.approvedByName">how_to_reg</mat-icon>
                  <mat-icon *ngIf="!item?.approvedByName">done</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="item?.productName == productNames.Facade && !released">
                <div *ngIf="!top100 && !released">|</div>
                <button mat-icon-button 
                        [disabled]="!item?.higherResVersion && !released"
                        color="accent"
                        (click)="openLinkInNewWindow($event, '/situ-facade', { id: item.higherResVersion });"
                        matTooltip="situFACADE">
                  <mat-icon>4k</mat-icon>
                </button>
                <button mat-icon-button
                        [disabled]="!item?.higherResVersion && !released"
                        color="accent"
                        (click)="openSituLinkInNewWindow($event, item.higherResVersion, true);"
                        matTooltip="situFACADE">
                  <mat-icon>share</mat-icon>
                </button>
                <!-- the 4k tick: serves the 4k in place of the 2k -->
                <button mat-icon-button
                        [disabled]="!item?.higherResVersion || isServed(item, item?.higherResVersion)"
                        [color]="isServed(item, item?.higherResVersion) ? 'accent' : 'primary'"
                        (click)="approveVersion(item, releaseItemVersions.HigherRes, '4k facade'); $event.stopPropagation();"
                        [matTooltip]="item?.higherResVersion ? versionTooltip(item, item?.higherResVersion, '4k facade') : 'No 4k version yet'">
                  <mat-icon *ngIf="isServed(item, item?.higherResVersion)">how_to_reg</mat-icon>
                  <mat-icon *ngIf="!isServed(item, item?.higherResVersion)">done</mat-icon>
                </button>
              </ng-container>

              <div>|</div>
              <situ-furnish-menu
                      [company]="selectedCompany"
                      [home]="furnishHomeName(item?.home)"
                      [ifcFiles]="furnishOptions(item)"
                      (click)="$event.stopPropagation()"
                      (selectedHomeIfcFileId)="openSituFurnishInNewWindow($event)">
                <button mat-icon-button color="primary" matTooltip="Furnish with situFURNISH">
                  <mat-icon class="option-icon">chair</mat-icon>
                </button>
              </situ-furnish-menu>

              <div *ngIf="!top100 && !released">|</div>
              <!-- <ng-container *ngIf="!isSituUser">
                <button *ngIf="!released" mat-icon-button [disabled]="!item?.comments?.trim()"
                  color="accent"
                  (click)="$event.stopPropagation();"
                  [matTooltip]="item?.comments?.trim() ? item.comments : ''">
                  <mat-icon>comment</mat-icon>
                </button>
                <button *ngIf="!released" mat-icon-button [disabled]="!item?.supportTask?.trim()"
                  color="accent"
                  (click)="$event.stopPropagation();"
                  [matTooltip]="item?.supportTask?.trim() ? item.supportTask  : ''">
                  <mat-icon>support</mat-icon>
                </button>
              </ng-container> -->
              <ng-container>
                <button *ngIf="!released" mat-icon-button [disabled]="!item?.releaseIssueReleaseItems?.length > 0"
                  color="primary"
                  (click)="$event.stopPropagation();"
                  matTooltip="{{ item?.releaseIssueReleaseItems?.length + ' issues' }}">
                  <mat-icon>bug_report</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      </ng-container>
      <div #showMoreProductsMarker fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
        <mat-card *ngIf="hasMoreProductsToShow()" class="contrast card-link banner-info w-100" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="showMoreProducts()">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
              <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <mat-card fxFlex *ngIf="released && !top100">
        <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
          [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </mat-card>
    </mat-card-content>
  </mat-card>
  <!-- Release Items -->
</div>
